<template>
  <div class="delete-link">
    <div class="link" @click="deletePost()">
      <span>{{ $t('administrator.deletePost.delete') }}</span>
    </div>
    <modal-confirm
      class="confirm-delete"
      @click.stop
      @confirm="confirmDelete()"
      @close="closeModal()"
      :cancel="$t('administrator.deletePost.no')"
      :confirm="$t('administrator.deletePost.yes')"
      :title="$t('administrator.deletePost.deletePost')"
      :message="$t('administrator.deletePost.deleteConfirmation')"
      :show-modal="showModal"
    />
  </div>
</template>

<script>
import ModalConfirm from '@/components/shared/ModalConfirm'

export default {
  name: 'DeletePost',
  components: { ModalConfirm },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    deletePost () {
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    },
    async confirmDelete () {
      this.closeModal()
      let message = this.$t('administrator.deletePost.postDeleted')
      let success = await this.$store.dispatch('softDeleteReportedPost', this.post.id)
      if (success) {
        this.$toasted.global.success(message)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .delete-link {
    width: 100%;
    .link {
        color: $primary-color;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -ms-flex-pack: start;
        justify-content: flex-start;
        align-items: center;
        padding: 4px 12px;

        &:hover  {
          cursor: pointer;
          background-color: $primary-color;
          color: white;
        }
      }
  }
</style>
